import { supabase } from '../../lib/supabase';

export interface OpportunityProduct {
    id: string;
    opportunity_id: string;
    product_id: string | null;
    name: string;
    quantity: number;
    unit_price: number;
    total_price: number;
}

export class SupabaseOpportunityProductRepository {
    static async getByLeadId(leadId: string): Promise<OpportunityProduct[]> {
        const { data, error } = await supabase
            .from('opportunity_products')
            .select('*')
            .eq('opportunity_id', leadId)
            .order('created_at', { ascending: true });

        if (error) throw error;
        return data || [];
    }

    static async add(product: Omit<OpportunityProduct, 'id' | 'total_price'>): Promise<OpportunityProduct> {
        const { data, error } = await supabase
            .from('opportunity_products')
            .insert({
                opportunity_id: product.opportunity_id,
                product_id: product.product_id,
                name: product.name,
                quantity: product.quantity,
                unit_price: product.unit_price
            })
            .select()
            .single();

        if (error) throw error;
        return data;
    }

    static async remove(id: string): Promise<void> {
        const { error } = await supabase
            .from('opportunity_products')
            .delete()
            .eq('id', id);

        if (error) throw error;
    }

    static async update(id: string, updates: Partial<OpportunityProduct>): Promise<void> {
        const { error } = await supabase
            .from('opportunity_products')
            .update(updates)
            .eq('id', id);

        if (error) throw error;
    }
}
